import React from 'react';
import { Status } from '../types';
interface StatusBadgeProps {
  status: Status;
  className?: string;
}
export function StatusBadge({
  status,
  className = ''
}: StatusBadgeProps) {
  let styles = '';
  switch (status) {
    case 'Draft':
      styles = 'bg-[#64748B]/20 text-[#94A3B8] border-[#64748B]/30';
      break;
    case 'Direncanakan':
      styles = 'bg-[#A855F7]/15 text-[#A855F7] border-[#A855F7]/30 glow-purple';
      break;
    case 'Baru':
      styles = 'bg-[#00D4FF]/15 text-[#00D4FF] border-[#00D4FF]/30 glow-cyan';
      break;
    case 'Berjalan':
      styles = 'bg-[#0EA5E9]/15 text-[#0EA5E9] border-[#0EA5E9]/30';
      break;
    case 'Menunggu Verifikasi':
      styles = 'bg-[#FFB800]/15 text-[#FFB800] border-[#FFB800]/30 glow-amber';
      break;
    case 'Tertunda':
      styles = 'bg-[#FF3B3B]/15 text-[#FF3B3B] border-[#FF3B3B]/30 glow-red';
      break;
    case 'Selesai':
      styles = 'bg-[#00FF88]/15 text-[#00FF88] border-[#00FF88]/30 glow-green';
      break;
    case 'Dibatalkan':
      styles = 'bg-[#475569]/20 text-[#94A3B8] border-[#475569]/30';
      break;
    default:
      styles = 'bg-[#64748B]/20 text-[#94A3B8] border-[#64748B]/30';
  }
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded text-xs font-bold uppercase tracking-wider border ${styles} ${className}`} data-id="element-83">
      {status}
    </span>;
}